module.exports = __webpack_public_path__ + "static/img/jq_indicator.png";